var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeachers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0488 15.5316C18.5663 15.5316 19.0626 15.326 19.4285 14.9601C19.7944 14.5942 20 14.0979 20 13.5804V2.84868C20 2.33118 19.7944 1.83488 19.4285 1.46896C19.0626 1.10304 18.5663 0.897461 18.0488 0.897461H7.76585C8.10732 1.49258 8.29268 2.16575 8.29268 2.84868H18.0488V13.5804H9.26829V15.5316M13.1707 5.77551V7.72673H7.31707V20.4097H5.36585V14.556H3.41463V20.4097H1.46341V12.6048H0V7.72673C0 7.20923 0.205574 6.71293 0.571499 6.34701C0.937424 5.98108 1.43372 5.77551 1.95122 5.77551H13.1707ZM6.34146 2.84868C6.34146 3.36618 6.13589 3.86248 5.76996 4.2284C5.40404 4.59433 4.90774 4.7999 4.39024 4.7999C3.87275 4.7999 3.37645 4.59433 3.01052 4.2284C2.6446 3.86248 2.43902 3.36618 2.43902 2.84868C2.43902 2.33118 2.6446 1.83488 3.01052 1.46896C3.37645 1.10304 3.87275 0.897461 4.39024 0.897461C4.90774 0.897461 5.40404 1.10304 5.76996 1.46896C6.13589 1.83488 6.34146 2.33118 6.34146 2.84868Z",
    fill: "#42424E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachers);
export default __webpack_public_path__ + "static/media/teachers.701ba915d35977a2cb996fc5bc1e05d4.svg";
export { ForwardRef as ReactComponent };